import { render, staticRenderFns } from "./HideableText.vue?vue&type=template&id=bba3cee4&scoped=true&"
import script from "./HideableText.vue?vue&type=script&lang=js&"
export * from "./HideableText.vue?vue&type=script&lang=js&"
import style0 from "./HideableText.vue?vue&type=style&index=0&id=bba3cee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3cee4",
  null
  
)

export default component.exports